<div>
    <div class="columns is-multiline">
        <div class="column is-2">
            <app-datepicker [selectedDate]="date" (dateChange)="onDateChange($event)"></app-datepicker>
        </div>

        <div class="column is-2">
            <span class="select-label">Blenders</span><br>
            <p-multiSelect 
                [options]="blenders"
                optionLabel= "id"
                [(ngModel)]="selectedBlenders" 
                filter="false"
                placeholder="Seleccionar"
                showClear="true"
                (onClear)="selectedBlenders = []"
                showHeader="false">
                <ng-template let-blender pTemplate="item">
                    <div>Blender {{ blender.id }}</div>
                </ng-template>
            </p-multiSelect>
        </div>

        <div class="column is-2">
            <span class="select-label">Envasadoras</span><br>
            <p-multiSelect 
                [options]="packagingMachines"
                optionLabel="id"
                [(ngModel)]="selectedPackagingMachines"
                filter="false"
                placeholder="Seleccionar"
                showClear="true"
                (onClear)="selectedPackagingMachines = []"
                showHeader="false"
            /> 
        </div>
        <div class="column is-6 switch-container">
            <label class="switch-label">Timeline</label>
            <p-inputSwitch [(ngModel)]="isTableView"/>
            <label class="switch-label">Tabla</label>
        </div>
      
        @if(!isTableView) {
            <div class="column is-12">
                <app-timeline 
                    [blenderTasks]="filteredBlenderTasks"
                    [packagingTasks]="filteredPackagingTasks"
                    [blenders]="(selectedBlenders.length > 0 ? selectedBlenders : blenders)" 
                    [packagingMachines]="(selectedPackagingMachines.length > 0 ? selectedPackagingMachines : packagingMachines)"
                    [calendar]="calendar"
                    [selectedDate]="date"
                    [cameraHeatmapSegments]="cameraHeatmapSegments"
                    [showCameraHeatmapRow]="true"
                    (dateIncrement)="onDateIncrement($event)">
                </app-timeline>
            </div>
        } @else {
            <div class="column is-12">
                <app-drag-and-drop-table [data]="tableTasks" (dataChange)="onTasksOrderChange($event)"></app-drag-and-drop-table>
            </div>
        }
    </div>
</div>
